(function () {
  'use strict';

  const MILES_CONSTANT = 1.60934,
      MILES_CONSTANT_MINUS_ONE = 0.60934;

  class MeasurementUnitConverterService {

    constructor() { }

    getDateTimeFormat(dateTimeFormat) {
      return dateTimeFormat === 'BRITISH' ? 'dd/MM/yy HH:mm:ss' : 'MM/dd/yy HH:mm:ss';
    }

    getDateFormat(dateTimeFormat) {
      return dateTimeFormat === 'BRITISH' ? 'dd/MM/yyyy' : 'MM/dd/yyyy';
    }

    getDateTimeFormatYearWithTwo(dateTimeFormat) {
      return dateTimeFormat === 'BRITISH' ? 'dd/MM/yy' : 'MM/dd/yy';
    }

    getDistanceUnit(distanceMeasurement) {
      return distanceMeasurement === 'KM' ? 'Km' : 'mi';
    }

    getSpeedUnit(speedMeasurement) {
      return speedMeasurement === 'KM' ? 'Km/h' : 'mph';
    }

    getFuelUnit(fuelMeasurement) {
      return fuelMeasurement === 'LITERS' ? 'L' : 'gal';
    }

    getFuelEfficiencyUnit(fuelMeasurement) {
      return fuelMeasurement === 'LITERS' ? 'Km/L' : 'mpg';
    }

    getEnergyEfficiencyUnit(fuelMeasurement) {
      return fuelMeasurement === 'LITERS' ? 'Km/kWh' : 'mi/kWh';
    }

    convertSpeedFromMphToKmh(speed) {
      if (speed === null || angular.isUndefined(speed) || isNaN(speed)) {
        throw new Error('Invalid value for kmh');
      }
      if (speed === 0) return 0;
      return Math.ceil(speed * MILES_CONSTANT + MILES_CONSTANT_MINUS_ONE);
    }

    convertSpeedFromKmhToMph(speed) {
      if (speed === null || angular.isUndefined(speed) || isNaN(speed)) {
        throw new Error('Invalid speed value');
      }
      if (speed === 0) return 0;
      return Math.floor(speed / MILES_CONSTANT);
    }
}

  angular
    .module('ModuleMeasurementUnitConverter', [])
    .service('MeasurementUnitConverterService', MeasurementUnitConverterService);
}());
